// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"Display_main_wrapper__3dQMp","component":"Display_component__2G8U9","props":"Display_props__HoUI7","code":"Display_code__2hEmk"};